import React from 'react';
import MusicManagementView from './components/music/MusicManagementView';
import MusicAlbumFirstPage from './components/music_release/MusicAlbumFirstPage';
import MusicAlbumListView from './components/music_release/MusicAlbumListView';
import MusicAlbumDetailsView from './components/music_release/MusicAlbumDetailsView';
import MusicAlbumEditForm1 from './components/music_release/MusicAlbumEditForm1';
import MusicAlbumEditForm2 from './components/music_release/MusicAlbumEditForm2';
import MusicAlbumEditForm3 from './components/music_release/MusicAlbumEditForm3';
import MusicAlbumEditForm4 from './components/music_release/MusicAlbumEditForm4';
import { MusicDistributionClientContext, defaultMusicDistributionClient } from './context/MusicDistributionClientContext';
import { MusicClientContext, defaultMusicClient } from './context/MusicClientContext';
import { MusicAlbumArtistEntity, MusicAlbumEntity, MusicAlbumTrackEntity } from './types/MusicAlbumEntityTypes';
import { MusicComposerEntity, MusicEntity, MusicFeaturingArtistEntity, MusicLyricWriterEntity } from './types/MusicEntityTypes';
import { TunecoreReleaseEntity, TunecoreReleaseTrackEntity } from './types/TunecoreReleaseEntityTypes';

const components = {
  MusicManagementView: (props: {
    pageCount: number,
    initialDefaultPermissionToUse: number,
  }) => (
    <MusicClientContext.Provider value={defaultMusicClient}>
      <MusicManagementView {...props} />
    </MusicClientContext.Provider>
  ),
  MusicAlbumFirstPage: (props: {
    isLoggingIn: boolean,
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumFirstPage
        {...props} // eslint-disable-line react/jsx-props-no-spreading
      />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumDetailsView: (props: {
    musicAlbum: MusicAlbumEntity & {
      music_album_tracks: (MusicAlbumTrackEntity & {
        music: MusicEntity & {
          tunecore_release_track: TunecoreReleaseTrackEntity,
        },
      })[],
      tunecore_release: TunecoreReleaseEntity,
    }
    cancelReasonOptions: {
      text: string,
      value: string,
    }[],
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumDetailsView {...props} />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumListView: (props: {
    userInfoFilled: boolean,
    hasMusic: boolean,
    cancelReasonOptions: {
      text: string,
      value: string,
    }[],
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumListView {...props} />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumEditForm1: (props: {
    musicAlbum: MusicAlbumEntity & {
      music_album_artists: MusicAlbumArtistEntity[],
      music_album_tracks: (MusicAlbumTrackEntity & {
        music: MusicEntity,
      })[],
    },
    genreOptions: {
      value: string
      text: string,
    }[],
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumEditForm1 {...props} />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumEditForm2: (props: {
    musicAlbum: MusicAlbumEntity & {
      music_album_tracks: (MusicAlbumTrackEntity & {
        music: MusicEntity & {
          music_featuring_artists: MusicFeaturingArtistEntity[],
        },
      })[],
    }
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumEditForm2 {...props} />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumEditForm3: (props: {
    musicAlbum: MusicAlbumEntity & {
      music_album_artists: MusicAlbumArtistEntity[],
      music_album_tracks: (MusicAlbumTrackEntity & {
        music: MusicEntity & {
          music_featuring_artists: MusicFeaturingArtistEntity[],
          music_composers: MusicComposerEntity[],
          music_lyric_writers: MusicLyricWriterEntity[],
          tunecore_release_track: TunecoreReleaseTrackEntity,
        },
      })[],
    },
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumEditForm3 {...props} />
    </MusicDistributionClientContext.Provider>
  ),
  MusicAlbumEditForm4: (props: {
    musicAlbum: MusicAlbumEntity & {
      music_album_tracks: (MusicAlbumTrackEntity & {
        music: MusicEntity & {
          music_lyric_writers: MusicLyricWriterEntity[],
          music_composers: MusicComposerEntity[],
        }
      })[],
    },
  }) => (
    <MusicDistributionClientContext.Provider value={defaultMusicDistributionClient}>
      <MusicAlbumEditForm4 {...props} />
    </MusicDistributionClientContext.Provider>
  ),
};

if (!window.AppComponents) window.AppComponents = {};
(Object.keys(components) as (keyof typeof components)[]).forEach((name) => {
  window.AppComponents[name] = components[name];
});
